import { useState } from "react";
import { contingenciesHtml } from "./contingenciesHtml.js";

const StopLossMarkdownField = ({ value, onChange, onFocus, onBlur, placeholder }) => {
    const [mode, setMode] = useState("write");
    const text = value || "";
    const html = contingenciesHtml(text);

    return (
        <div className="commercial-proposal__markdown">
            <div className="commercial-proposal__markdown-bar">
                <span>Stop loss contingencies</span>
                <div role="tablist" aria-label="Stop loss contingencies editor">
                    <button type="button" role="tab" aria-selected={mode === "write"} onClick={() => setMode("write")}>Write</button>
                    <button type="button" role="tab" aria-selected={mode === "preview"} onClick={() => setMode("preview")}>Preview</button>
                </div>
            </div>
            {mode === "write" ? (
                <textarea
                    rows={8}
                    aria-label="Stop loss contingencies"
                    placeholder={placeholder}
                    value={text}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={(event) => onChange(event.target.value)}
                />
            ) : (
                <div
                    className="commercial-proposal__markdown-preview"
                    aria-label="Stop loss contingencies preview"
                    dangerouslySetInnerHTML={{
                        __html: html || "<p>Nothing to preview yet.</p>",
                    }}
                />
            )}
        </div>
    );
};

export default StopLossMarkdownField;
